export const UTM_NOT_ALLOWED = ['companyId', 'redirectTo', 'item_id'];
